import type { HTMLAttributes, ReactNode } from 'react'
import EmptyPlaceholder from '../EmptyPlaceholder'
import PageLoading from '../PageLoading'
import styles from './CommentListContent.module.css'

export interface CommentListContentProps extends HTMLAttributes<HTMLDivElement> {
	children: ReactNode
	empty: boolean
	isLoading?: boolean
}

export default function CommentListContent({
	children,
	empty,
	isLoading = false,
	...props
}: CommentListContentProps) {
	return (
		<div {...props}>
			{isLoading ? (
				<PageLoading className={styles.loading} inline />
			) : empty ? (
				<EmptyPlaceholder title="暂无评论" className={styles.emptyPlaceholder} />
			) : (
				<div className={styles.comments}>{children}</div>
			)}
		</div>
	)
}
